import React from 'react'

function Pre_Loader() {
    return (
        <div className="preloader flex-column justify-content-center align-items-center">
            <img className="animation__shake" src="dist/img/logo-2.png" alt="Preloader icon" height={100} width={100} />
        </div>
    )
}

export default Pre_Loader